import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import useReactRouterBreadcrumbs from 'use-react-router-breadcrumbs';
import { RoutesNames } from '../../../globals';

// ICONS
import { styled } from '@mui/material';
import { IoMdHome as HomeIcon } from 'react-icons/io';
import { MdOutlineArrowForwardIos as DividerIcon } from 'react-icons/md';

// STYLE
const breadcrumbAlignItem: React.CSSProperties = { display: 'flex', alignSelf: 'center' }
const breadcrumbLinkDecoration: React.CSSProperties = { textDecoration: 'none', color: '#166CC8' }
const colorUnlink: React.CSSProperties = { color: '#606060' }

const BreadcrumbWrapperStyled = styled('div')(({ theme }) => ({
  display: 'flex',
  width: '100%',
  paddingBlock: 10,
  paddingInline: 10,
  boxSizing: 'border-box',
  [theme.breakpoints.up('sm')]: {
    paddingInline: 20,
  }
}))

export const BreadcrumbComponent = (props: {
  props?: React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
}) => {
  const unLink = [
    '/z',
    '/blabla'
  ]

  const location = useLocation()
  const breadcrumbs = useReactRouterBreadcrumbs([
    {
      path: RoutesNames.home,
      breadcrumb: 'Home'
    },
    {
      path: RoutesNames.sports,
      breadcrumb: 'Esportes',
      children: [{
        path: RoutesNames.sport,
      }]
    },
    {
      path: RoutesNames.events,
      breadcrumb: 'Eventos',
      children: [{
        path: RoutesNames.event,
      }]
    },
    {
      path: RoutesNames.users,
      breadcrumb: 'Usuários',
      children: [{
        path: RoutesNames.user,
      }]
    },
    {
      path: RoutesNames.locations,
      breadcrumb: 'Localizações',
      children: [{
        path: RoutesNames.location,
      }]
    },
    {
      path: RoutesNames.tournaments,
      breadcrumb: 'Torneios',
      children: [{
        path: RoutesNames.tournament,
      }]
    },
    {
      path: RoutesNames.participants,
      breadcrumb: 'Participantes',
      children: [{
        path: RoutesNames.participant,
      }]
    },
    {
      path: RoutesNames.usersGroups,
      breadcrumb: 'Grupos de usuários',
      children: [{
        path: RoutesNames.userGroup,
      }]
    },
    {
      path: RoutesNames.tasks,
      breadcrumb: 'Tarefas',
      children: [{
        path: RoutesNames.task,
      }]
    },
    {
      path: RoutesNames.companies,
      breadcrumb: 'Empresas',
      children: [{
        path: RoutesNames.company,
      }]
    },
    {
      path: RoutesNames.authorizations,
      breadcrumb: 'Autorizações',
      children: [{
        path: RoutesNames.authorization,
      }]
    },
    {
      path: RoutesNames.logsClassifications,
      breadcrumb: 'Classificação de Logs',
      children: [{
        path: RoutesNames.logsClassification,
      }]
    },
  ]);

  const checkArrays = (arrayA: any[], arrayB: any[]) => arrayA.some(r => arrayB.indexOf(r) >= 0)

  return <>
    <BreadcrumbWrapperStyled {...props.props}>
      {breadcrumbs.map((args, index) => {
        return <React.Fragment key={index}>
          {/* HOME */}
          {args.match.pathname == RoutesNames.home ?
            <Link style={breadcrumbAlignItem} to={args.match.pathname}>
              <HomeIcon style={{ ...breadcrumbAlignItem, color: '#166CC8', marginRight: 5 }} />
            </Link> : null}

          <span style={{ ...breadcrumbAlignItem }}>
            {/* ARROW DIVIDER */}
            {args.match.pathname != RoutesNames.home ?
              <DividerIcon style={{ ...breadcrumbAlignItem, margin: '0px 5px 0px 5px', color: '#505050' }} /> : null}

            {/* PATH/ROUTES NAMES */}
            {args.match.params.id == ':id' ? 'Novo' : location.pathname == args.match.pathname ?
              <div style={colorUnlink}> {args.breadcrumb}</div> :
              checkArrays([args.match.pathname], unLink) ?
                <div style={colorUnlink}>{args.match.route?.breadcrumb as string}</div> :
                <Link style={breadcrumbLinkDecoration} to={args.match.pathname}>{args.breadcrumb}</Link>}
          </span>
        </React.Fragment>
      })}
    </BreadcrumbWrapperStyled>
  </>
}